import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		fill="none"
		viewBox="0 0 16 16"
		{...props}
	>
		<g
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			clipPath="url(#clip0_678_4019)"
		>
			<path d="M10.436 2.111a2 2 0 0 1 2.851-.023l.642.642a2 2 0 0 1-.005 2.834l-8.256 8.19a1.33 1.33 0 0 1-.747.372l-3.565.518.675-3.534c.049-.255.17-.49.351-.677zM9.191 4.001l2.932 2.932" />
		</g>
		<defs>
			<clipPath id="clip0_678_4019">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);
export { SvgComponent as EditIcon };
